
/**
*	//////////////// KBmodal OBJECT	////////////////
**/

// KBmodal Object constructor;
function KBmodal(url, type, objname, gallery, notcloseable) {
    
    var self = this;

    self.name = objname;
    self.contentType = type;
    self.contentUrl = url; // or html content if type is set to "html"
    self.closeable = notcloseable;
    if (typeof gallery != "undefined") {
        self.galleryName = gallery;
        self.galleryItems = [];
    }

    // methods;

    self.openModal = function (){
        // create global js variable with created object name;
        KBmodal_name = self.name;

        // create gallery array if data-content-gallery of clicked element is set
        if (typeof self.galleryName != "undefined") {
            createGalleryArray();
        }

        var modalBody = "<div class='KBmodal__opened' modalName='"+self.name+"'>";
        // modal content;

        switch(self.contentType) {
        case "yt":
            modalBody +=  generateYoutubeModal();
            break;
        case "image":
            modalBody += generateImageModal();
            break;
        case "gallery":
            modalBody +=  generateGalleryModal();
            break;
        case "html":
            modalBody +=  generateHTMLModal();
            break;
        default:
            modalBody += generateImageModal();
        }

        // modal content end
        modalBody += "</div>";

        // show modal;
        jQuery("body").append(modalBody);

        // resize modals on their generation (responsive)
        switch(self.contentType) {
        case "yt":
            resizeModalYt();
            break;
        case "image":
            resizeModalImage();
            break;
        case "gallery":
            resizeModalImage();
            break;
        default:
            resizeModalImage();
        }

        if (self.contentType === "gallery") {
            if (KBcurrent_item === 0) {
                $(".KBprev").addClass("disable-arrow");
            } else if (KBcurrent_item === (self.galleryItems.length - 1)) {
                $(".KBnext").addClass("disable-arrow");
            }
        }
    };

    self.closeModal = function (){
        jQuery("[modalName="+self.name+"]").remove();
    };

    generateImageModal = function (){
        var modalBody;

        modalBody = "<div class='KBmodal__image'>";

        modalBody += "<div class='modal-inner'><img src='"+self.contentUrl+"'><div class='modal-close'><svg viewBox='0 0 18 19' xmlns='http://www.w3.org/2000/svg'><path d='M.293 18.322a1 1 0 0 1 0-1.415l16-16a1 1 0 0 1 1.414 1.415l-16 16a1 1 0 0 1-1.414 0Z'/><path d='M.293.907a1 1 0 0 1 1.414 0l16 16a1 1 0 0 1-1.414 1.414l-16-16a1 1 0 0 1 0-1.414Z'/></svg></div></div>";

        modalBody += "</div>";

        return modalBody;
    };

    self.notcloseable = function (){
        if (self.closeable == "0") {
            return true;
        }else{
            return false;
        }
    };
    
    generateHTMLModal = function (){
        var modalBody;

        modalBody = "<div class='KBmodal__html'>";

        modalBody += self.contentUrl;

        modalBody += "</div>";
        return modalBody;
    };

    generateGalleryModal = function (){

        // set clicked item as current(opened) gallery item
        for (var i = 0; i <= self.galleryItems.length-1; i++) {
            if (self.galleryItems[i] == self.contentUrl) {
                KBcurrent_item = i;
            }
        }

        var modalBody;

        modalBody = "<div class='KBmodal__image'>";

        modalBody += "<div class='KBgalleryNav KBprev'><svg xmlns='http://www.w3.org/2000/svg' class='mb-icon' viewBox='0 0 256 512'><path d='M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z'/></svg><svg viewBox='0 0 83 12' xmlns='http://www.w3.org/2000/svg'><path d='M10 11.547 0 5.773 10 0v4.774h71.347a1 1 0 0 1 0 2H10v4.773Z'/></svg></div>";

        modalBody += "<div class='modal-inner'><img src='"+self.contentUrl+"'><div class='modal-close'><svg viewBox='0 0 18 19' xmlns='http://www.w3.org/2000/svg'><path d='M.293 18.322a1 1 0 0 1 0-1.415l16-16a1 1 0 0 1 1.414 1.415l-16 16a1 1 0 0 1-1.414 0Z'/><path d='M.293.907a1 1 0 0 1 1.414 0l16 16a1 1 0 0 1-1.414 1.414l-16-16a1 1 0 0 1 0-1.414Z'/></svg></div></div>";

        modalBody += "<div class='KBgalleryNav KBnext'><svg xmlns='http://www.w3.org/2000/svg' class='mb-icon' viewBox='0 0 256 512'><path d='M64 448c-8.188 0-16.38-3.125-22.62-9.375-12.5-12.5-12.5-32.75 0-45.25L178.8 256 41.38 118.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160c12.5 12.5 12.5 32.75 0 45.25l-160 160C80.38 444.9 72.19 448 64 448z'/></svg><svg viewBox='0 0 83 12' xmlns='http://www.w3.org/2000/svg'><path d='m73 0 10 5.774-10 5.773V6.773H1.651a1 1 0 0 1 0-2H73V0Z'/></svg></div>";

        modalBody += "</div>";
        return modalBody;

    };

    generateYoutubeModal = function (){
        var modalBody;
        var ytVideoID = (self.contentUrl).replace("https://www.youtube.com/watch?v=", "");

        modalBody = "<div class='KBmodal__yt'>";
        modalBody += '<div class="modal-inner"><iframe width="1280" height="720" src="https://www.youtube.com/embed/'+ytVideoID+'?color=red&enablejsapi=1&modestbranding=1&rel=1&autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe><div class="modal-close"><svg viewBox="0 0 18 19" xmlns="http://www.w3.org/2000/svg"><path d="M.293 18.322a1 1 0 0 1 0-1.415l16-16a1 1 0 0 1 1.414 1.415l-16 16a1 1 0 0 1-1.414 0Z"/><path d="M.293.907a1 1 0 0 1 1.414 0l16 16a1 1 0 0 1-1.414 1.414l-16-16a1 1 0 0 1 0-1.414Z"/></svg></div></div>';

        modalBody += "</div>";

        return modalBody;

    };

    resizeModalImage = function (){

        var $maxImageWidth = jQuery(".KBmodal__image").width();
        var $maxImageHeight = jQuery(".KBmodal__image").height();

        var $img = jQuery(".KBmodal__image img");

        $img.css({
            "max-width": $maxImageWidth,
            "max-height": $maxImageHeight
        });

    };

    resizeModalYt = function (){

        var $iframe = jQuery(".KBmodal__yt iframe");
        var $iframeWidth = jQuery(".KBmodal__yt iframe").width();

        $iframe.css({
            "height": $iframeWidth * 0.5625,
        });

    };

    createGalleryArray = function (){
        jQuery("[data-content-gallery="+self.galleryName+"]").each(function () {
            self.galleryItems.push(jQuery(this).attr("data-content-url"));
        });
    };

    // resize modals on screen resize (responsive)
    jQuery( window ).resize(function () {

        switch(self.contentType) {
        case "yt":
            resizeModalYt();
            break;
        case "image":
            resizeModalImage();
            break;
        case "gallery":
            resizeModalImage();
            break;
        default:
            resizeModalImage();
        }

    });

}

// (function($){
// KBmodal functions

/* 
    // Variables accessible outside KBmodal object

    KBmodal_name - name of opened KBmodal object
    KBcurrent_item - array index of clicked gallery element (only set if clicked element is type of gallery)

*/

function generateKBmodal(url, type, gallery, name, notcloseable){
    var modalID = Math.floor((Math.random() * 100) + 1);

    if (typeof name != "undefined") {
        var modalName = name;
    } else{
        var modalName = "KBmodal"+modalID;
    }

    window[modalName] = new KBmodal(url, type, modalName, gallery, notcloseable);
    window[modalName].openModal();
}

function KBprevAction(){

    if (typeof KBcurrent_item !== "undefined") {

        if (KBcurrent_item>0) {
            KBcurrent_item = KBcurrent_item - 1;
        }else{
            KBcurrent_item = KBcurrent_item;
        }

        jQuery("[modalname='"+KBmodal_name+"']").find("img").attr("src", window[KBmodal_name].galleryItems[KBcurrent_item]);

        if (KBcurrent_item === 0) {
            return "disable";
        }
    }
    
}

function KBnextAction(){

    if (typeof KBcurrent_item !== "undefined") {

        if (KBcurrent_item<window[KBmodal_name].galleryItems.length-1) {
            KBcurrent_item = KBcurrent_item + 1;
        }else{
            KBcurrent_item = KBcurrent_item;
        }

        jQuery("[modalname='"+KBmodal_name+"']").find("img").attr("src", window[KBmodal_name].galleryItems[KBcurrent_item]);

        if (KBcurrent_item === window[KBmodal_name].galleryItems.length-1) {
            return "disable";
        }
    }

}

function KBcloseAction(modalName, forceClose){
    if (typeof modalName !== "undefined") {
        var name = modalName;
    }else{
        var name = KBmodal_name;
    }
    if (!forceClose) {
        if (window[name].notcloseable()) {
            return;
        }
    }
    window[name].closeModal();
    delete window[name];
    openedModal = null;
}

// open KBmodal on '.KBmodal' class click
jQuery(document).on("click", ".popup-init", function (){
    var url = jQuery(this).attr("data-content-url");
    var type = (jQuery(this).attr("data-content-type") ? jQuery(this).attr("data-content-type") : "image");
    var gallery = jQuery(this).attr("data-content-gallery");
    var notcloseable = jQuery(this).attr("data-closable");

    generateKBmodal(url, type, gallery, undefined, notcloseable);
});

// close modal and remove object
jQuery(document).on("click", ".KBmodal__opened", function (e){

    e.stopPropagation();
    KBcloseAction();

});
jQuery(document).on("click", ".KBmodal__html", function (e){

    e.stopPropagation();

});

jQuery(document).keydown(function (e) {
    if ($(".KBmodal__opened").length) {
        switch(e.which) {
        case 37: //left arrow key
    
            KBprevAction();
    
            break;
    
        case 39:
    
            KBnextAction(); //right arrow key
    
            break;
    
        case 27:
    
            KBcloseAction(); //esc key
    
            break;
    
        default: return; // exit this handler for other keys
        }
        e.preventDefault(); // prevent the default action (scroll / move caret)
    }
});

jQuery(document).on("click", ".KBprev", function (e){
    e.stopPropagation();

    KBprevAction();

    if (KBprevAction() === "disable") {
        $(this).addClass("disable-arrow");
    }

    $(".KBnext").removeClass("disable-arrow");
});

jQuery(document).on("click", ".KBnext", function (e){
    e.stopPropagation();

    KBnextAction();

    if (KBnextAction() === "disable") {
        $(this).addClass("disable-arrow");
    }

    $(".KBprev").removeClass("disable-arrow");
});

/**
*	//////////////// KBmodal OBJECT end	////////////////
**/
// })(jQuery);



// WEBPACK FOOTER //
// ./assets/js/libs/KBmodal.js